import { motion } from "framer-motion";
import { PROFILE } from "../data/links";

const EASE = [0.16, 1, 0.3, 1];

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden pt-14 pb-8 md:pt-20 md:pb-12"
    >
      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="flex items-center gap-4 mb-6"
        >
          <img
            src={PROFILE.avatar}
            alt="TEZZO"
            className="w-14 h-14 object-cover grayscale contrast-125 border border-white/15"
          />
          <span data-testid="hero-handle" className="font-mono-t text-sm tracking-[0.2em] text-white/70">
            {PROFILE.handle}
          </span>
        </motion.div>

        <div className="overflow-hidden">
          <motion.div
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, ease: EASE, delay: 0.15 }}
          >
            <h1
              className="font-gothic chrome-text text-[clamp(4rem,18vw,15rem)] leading-[0.82] tracking-tight select-none whitespace-nowrap"
              style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/chrome.jpg)` }}
            >
              TEZZO
            </h1>
          </motion.div>
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="font-mono-t text-sm text-white/50 mt-6"
        >
          {PROFILE.bio}
        </motion.p>
      </div>
    </section>
  );
}
